// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4494":"5791ffccd75196c5","5166":"21235bbf20df94fc","6328":"753d3acaa803bae4","9190":"fdfcbbc0d18684c5"}[chunkId] + ".js";
};